/** Map kids API product payloads to kids cart line items (list price only). */
export function kidsProductToCartLine(product) {
  return {
    item_id: product.item_id,
    name: product.name,
    price: product.price,
    thumbnail: product.thumbnail || null,
    quantity: 1,
    currency: product.currency || "KES",
    sub_category: product.sub_category || null,
    slug: product.slug,
    sizes: [],
  };
}
